import React, { FC, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAddConnector } from 'src/hooks/useAddConector';
import { ConnectorType } from 'src/utils/gql/types';
import { ROUTE_SOURCES } from 'src/constants/routeSources';

/** Evita doppio exchange dello stesso code (React StrictMode remount in dev). */
const usedOAuthCodes = new Set<string>();

export const AppInstalling: FC<{ type: ConnectorType }> = ({ type }) => {
  const hasRun = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code') || '';

  const { handleAddConnector } = useAddConnector({ code, type });

  useEffect(() => {
    if (!code) {
      navigate(`/${ROUTE_SOURCES.CONVERSATION}`, { replace: true });
      return;
    }

    const storageKey = `oauth_code_used:${type}:${code}`;
    if (hasRun.current || usedOAuthCodes.has(code) || sessionStorage.getItem(storageKey)) {
      return;
    }

    hasRun.current = true;
    usedOAuthCodes.add(code);
    sessionStorage.setItem(storageKey, '1');
    handleAddConnector();
  }, [handleAddConnector, code, navigate, type]);

  if (!code) {
    return null;
  }

  return <></>;
};
